module.exports = __webpack_public_path__ + "static/media/handschuhe_falsch_active_arbeitsmittel_true.bd91529b.jpg";